import { render, staticRenderFns } from "./NicknameModal.vue?vue&type=template&id=6f536f85&scoped=true"
import script from "./NicknameModal.vue?vue&type=script&lang=js"
export * from "./NicknameModal.vue?vue&type=script&lang=js"
import style0 from "./NicknameModal.vue?vue&type=style&index=0&id=6f536f85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f536f85",
  null
  
)

export default component.exports